import { render, staticRenderFns } from "./AdSlogen.vue?vue&type=template&id=f5c24ebc"
import script from "./AdSlogen.vue?vue&type=script&lang=js"
export * from "./AdSlogen.vue?vue&type=script&lang=js"
import style0 from "./AdSlogen.vue?vue&type=style&index=0&id=f5c24ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports